// extracted by mini-css-extract-plugin
export default {"tab":"U7wjb5ZnnG","tab_widthConstrained":"RDBVpSTZry"};